module.exports = __webpack_public_path__ + "static/media/positive.6088c090.png";